import axios from 'axios'

export function submitSignUpHubspotForm(formId, fields, pageUri, pageName) {
  const fields_json = []
  fields.forEach((field) => {
    fields_json.push({
      objectTypeId: field.id,
      name: field.name,
      value: field.value
    })
  })

  const json = {
    fields: fields_json,
    context: {
      pageUri: pageUri,
      pageName: pageName
    },
    legalConsentOptions: {
      consent: {
        // Include this object when GDPR options are enabled
        consentToProcess: true,
        text: 'I agree to allow RevArt Company to store and process my personal data.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 999,
            text: 'I agree to RevArt marketing communications from RevArt Company.'
          }
        ]
      }
    }
  }
  return axios.post('https://api.hsforms.com/submissions/v3/integration/submit/7839862/' + formId, json)
}

//  portalId: "7839862",
//  formId: "eddb8230-af3b-4c57-92fb-6edad341b693"
export function submitCancelAccountHubspotForm(formId, fields, pageUri, pageName) {
  const fields_json = []
  fields.forEach((field) => {
    fields_json.push({
      objectTypeId: field.id,
      name: field.name,
      value: field.value
    })
  })

  const json = {
    fields: fields_json,
    context: {
      pageUri: pageUri,
      pageName: pageName
    },
    legalConsentOptions: {
      consent: {
        // Include this object when GDPR options are enabled
        consentToProcess: true,
        text: 'I agree to allow RevArt Company to store and process my personal data.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 999,
            text: 'I agree to RevArt marketing communications from RevArt Company.'
          }
        ]
      }
    }
  }
  return axios.post('https://api.hsforms.com/submissions/v3/integration/submit/7839862/' + formId, json)
}

//   portalId: "7839862",
//   formId: "9484c820-6cad-4bfd-b668-117217596b81"
export function submitClickSubscribeHubspotForm(formId, fields, pageUri, pageName) {
  const fields_json = []
  fields.forEach((field) => {
    fields_json.push({
      objectTypeId: field.id,
      name: field.name,
      value: field.value
    })
  })

  const json = {
    fields: fields_json,
    context: {
      pageUri: pageUri,
      pageName: pageName
    },
    legalConsentOptions: {
      consent: {
        // Include this object when GDPR options are enabled
        consentToProcess: true,
        text: 'I agree to allow RevArt Company to store and process my personal data.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 999,
            text: 'I agree to RevArt marketing communications from RevArt Company.'
          }
        ]
      }
    }
  }
  return axios.post('https://api.hsforms.com/submissions/v3/integration/submit/7839862/' + formId, json)
}